const obterWhatsApps = async (app: string) => {
	const controller = new AbortController();

	try {
		const response = await fetch(`https://app.sak.com.br/centralAjudaApi/getwhatsapps/${app}`, {
			method: 'GET',
			signal: controller.signal,
		});

		const data = await response.json();
		return data;
	} catch (err) {
		console.error(err);
		return null;
	}
};

export default obterWhatsApps;
